import React from 'react'
import '../css/App.css';
import logoImg from '../assets/images/logo.jpg'
import { useState } from 'react';

const Login = () => {
    const [name,setName] = useState("");
    const [password,setPassword] = useState("");

    const handleSubmit = (e) => {
        console.log({name,password})
    }
    
  return (
    <section className='login'>
        <nav>
            <div className="container">
                <div className='nav-wrapper'>
                    <p className='login-nav__lang'>Русский</p>
                    <button className='login-nav_btn btn'>Выход</button>
                </div>
            </div>
        </nav>
        <main className='login-main'>
            <img src={logoImg} alt="Logo" className='login-logo'/>
            <form action="/" className='login-form' onSubmit={(e) => handleSubmit(e)}>
                <div className="form-div">
                    <label htmlFor="form-name">Пользователь</label>
                    <input 
                    type="text"
                    placeholder='Пользователь'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                    className='form-name__input' name='form-name'/>
                </div>
                <div className="form-div">
                    <label htmlFor="form-pass">Пароль</label>
                    <input 
                    type="password"
                    placeholder='Пароль'
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className='form-pass__input' name='form-pass'/>
                    <button type='submit' className='btn'>Войти</button>
                </div>
            </form>
        </main>
    </section>
  )
}

export default Login